/**
 * @generated SignedSource<<18bac5b64d63f80c40639a8e7a17f4bd>>
 * @relayHash da58e6aa3df25eb0a40f4ba9723e8b90
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 6c65e2eb0e9b435893fd8d4861fdd910104a9676ed04d471f1d54b947dd1ffec

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { ui_jiraCalendarQuery } from './ui_jiraCalendarQuery.graphql';

const node: PreloadableConcreteRequest<ui_jiraCalendarQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "6c65e2eb0e9b435893fd8d4861fdd910104a9676ed04d471f1d54b947dd1ffec",
    "metadata": {},
    "name": "ui_jiraCalendarQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
